import { useState, useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Hero from './components/Hero';
import Lessons from './components/Lessons';
import EquipmentRental from './components/EquipmentRental';
import WhyChooseUs from './components/WhyChooseUs';
import Testimonials from './components/Testimonials';
import ContactBooking from './components/ContactBooking';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-sand-50">
      <Navbar />
      <Hero scrolled={scrolled} />
      <Lessons />
      <EquipmentRental />
      <WhyChooseUs />
      <Testimonials />
      <ContactBooking />
      <Footer />
    </div>
  );
}
